import React from "react";
import { Input, Button } from "antd";
import { PlusOutlined, MinusOutlined, SearchOutlined } from "@ant-design/icons";

const ProductSelector = ({
  searchQuery,
  setSearchQuery,
  setCurrentPage,
  paginatedData,
  customMixItems,
  currentPage,
  totalPages,
  handlePreviousPage,
  handleNextPage,
  handleIncrease,
  handleDecrease,
  handleQuantityChange,
  shouldOpenWeightPopup,
  openWeightPopupForGrouped,
}) => {
  const renderProductCard = (item, index) => {
    const cartItem = customMixItems.find((ci) => ci.mProductId === item.mProductId);
    const uomName = item?.uomData?.[0]?.name ?? "";
    const quantity = cartItem ? cartItem.rawWeight || cartItem.weight : "0";
    const decimal = item?.uomData?.[0]?.decimal === "Y";
    const isSelected = !!cartItem;

    return (
      <div key={index} className={`cm-product-card${isSelected ? " cm-selected" : ""}`}>
        <div style={{ flex: 1, minWidth: 0, marginRight: 8 }}>
          <p className="cm-product-name" title={item.name}>{item.name}</p>
          <p className="cm-product-price">
            {item.sunitprice}{uomName ? ` - ${uomName}` : ""}
          </p>
        </div>
        <div className="cm-qty-controls">
          <Button
            onClick={() => handleDecrease(item)}
            className="cm-qty-btn"
            icon={<MinusOutlined style={{ fontSize: 12 }} />}
          />
          <Input
            type="text"
            value={quantity}
            readOnly={shouldOpenWeightPopup(item)}
            onClick={() => {
              if (shouldOpenWeightPopup(item)) {
                openWeightPopupForGrouped(item, async (updatedProduct) => {
                  const newValue = updatedProduct.rawWeight || updatedProduct.weight?.toString();
                  await handleQuantityChange(item, newValue);
                });
              }
            }}
            onKeyDown={(e) => {
              const currentValue = e.target.value;
              if (currentValue === "0" && /\d/.test(e.key) && !e.target.value.startsWith("0.")) {
                e.target.select();
              }
              if (decimal && e.key === "." && currentValue.includes(".")) { e.preventDefault(); return; }
              if (!decimal && !/[\d]/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) { e.preventDefault(); return; }
              if (decimal && !/[\d.]/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) { e.preventDefault(); return; }
            }}
            onChange={(e) => handleQuantityChange(item, e.target.value)}
            onBlur={(e) => {
              if (decimal && [".", "0.", "0.0", "0.00"].includes(e.target.value)) {
                handleQuantityChange(item, "0");
              }
            }}
            placeholder={decimal ? "0.001" : "1"}
            className="cm-qty-input"
          />
          <Button
            onClick={() => handleIncrease(item)}
            className="cm-qty-btn"
            style={{ background: "#2F3856", color: "#fff" }}
            icon={<PlusOutlined style={{ fontSize: 12 }} />}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <Input
        placeholder="Search item code / description"
        value={searchQuery}
        onChange={(e) => {
          // Mark productName so the global BarcodeGroupedHandler skips these
          // keystrokes — without this, typing in the mix search accumulates
          // dataString and an Enter could fire barcodeScanFromConfig and
          // silently push items into customMixItems. (Tab8 issue #11)
          if (e.target.value) localStorage.setItem("productName", e.target.value);
          else localStorage.removeItem("productName");
          setSearchQuery(e.target.value);
          setCurrentPage(0);
        }}
        onBlur={() => localStorage.removeItem("productName")}
        prefix={<SearchOutlined style={{ color: "#929098" }} />}
        className="cm-search-input"
        allowClear
      />
      <div className="cm-product-grid">
        {paginatedData.length > 0 ? (
          paginatedData.map((item, index) => renderProductCard(item, index))
        ) : (
          <div style={{ textAlign: "center", padding: "40px 0", color: "#aaa" }}>
            No products found
          </div>
        )}
      </div>
      {totalPages > 1 && (
        <div className="cm-pagination">
          <Button
            disabled={currentPage === 0}
            onClick={handlePreviousPage}
            className="cm-page-btn"
          >
            {"<"}
          </Button>
          <span className="cm-page-text">
            {currentPage + 1} / {totalPages}
          </span>
          <Button
            disabled={currentPage >= totalPages - 1}
            onClick={handleNextPage}
            className="cm-page-btn"
          >
            {">"}
          </Button>
        </div>
      )}
    </>
  );
};

export default ProductSelector;
